function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { string, bool, node } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';
import Label from '../label/Label';
import Error from '../error/Error';
import SelectBase from './styles/SelectBase';
import OptionBase from './styles/OptionBase';
import { colors } from '../colorSwatches';

function Select(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      label = _ref.label,
      _ref$noLabel = _ref.noLabel,
      noLabel = _ref$noLabel === void 0 ? false : _ref$noLabel,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? true : _ref$expand,
      setWidth = _ref.setWidth,
      setName = _ref.setName,
      defaultValue = _ref.defaultValue,
      required = _ref.required,
      validateNotEmpty = _ref.validateNotEmpty,
      _ref$editError = _ref.editError,
      editError = _ref$editError === void 0 ? false : _ref$editError,
      errorText = _ref.errorText,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      disabled = _ref.disabled;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      selectValue = _useState2[0],
      setSelectValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFocused = _useState6[0],
      setIsFocused = _useState6[1];

  var notEmptyValidation = selectValue.length === 0;

  var validationCondition = function validationCondition(condition, text) {
    if (condition) {
      if (editError === true) {
        setError(["".concat(errorText)]);
      } else {
        setError([text]);
      }
    }
  };

  var isNotEmpty = function isNotEmpty() {
    if (validateNotEmpty === true) {
      validationCondition(notEmptyValidation, "".concat(setName, " is required."));
    }
  };

  var focus = function focus() {
    setIsFocused(true);
  };

  var blur = function blur() {
    setIsFocused(false);
    isNotEmpty();
  };

  var onChangeFunc = function onChangeFunc(event) {
    setError(''); // add a validation method if you want the option to have the
    // validation message(s) remain while the user is typing

    setSelectValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn('scl-select', className),
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "select-wrapper",
    style: {
      width: expand === false && setWidth
    }
  }, noLabel === false ? /*#__PURE__*/React.createElement(Label, {
    labelFor: setName,
    required: required,
    label: label,
    color: colors.charcoalDefault
  }, error && /*#__PURE__*/React.createElement(Error, {
    "data-test-id": "error-with-label",
    errorColor: colors.error
  }, error), /*#__PURE__*/React.createElement(SelectBase, {
    key: uuidv4(),
    name: setName,
    onChange: onChangeFunc,
    value: selectValue,
    "data-test-id": "select-with-label",
    onFocus: focus,
    onBlur: blur,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(OptionBase, {
    key: uuidv4(),
    className: "option",
    value: "",
    disabled: true
  }, defaultValue), children)) : /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Error, {
    "data-test-id": "error-no-label",
    errorColor: colors.error
  }, error), /*#__PURE__*/React.createElement(SelectBase, {
    key: uuidv4(),
    name: setName,
    onChange: onChangeFunc,
    value: selectValue,
    "data-test-id": "select-no-label",
    onFocus: focus,
    onBlur: blur,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(OptionBase, {
    key: uuidv4(),
    className: "option",
    value: "",
    disabled: true
  }, defaultValue), children)));
}

Select.propTypes = {
  /**
   * Set a input's name
   */
  setName: string.isRequired,

  /**
   * Define label's text.
   */
  label: string,

  /**
   * Define a default value for the select's options.
   */
  defaultValue: string,

  /**
   * Only excepts a OptionBase component. View the Docs tab, and Show code to view the OptionBase component.
   */
  children: node.isRequired,

  /**
   * Define data analytics label.
   */
  dataAnalyticsLabel: string,

  /**
   * Define data analytics id.
   */
  dataAnalyticsId: string,

  /**
   * Define additional classNames.
   */
  className: string,

  /**
   * Define if component requires a label
   */
  noLabel: bool,

  /**
   * Define if input width is 100%.
   */
  expand: bool,

  /**
   * Set a input width (expand must be set to false).
   */
  setWidth: string,

  /**
   * Choose to make input required
   */
  required: bool,

  /**
   * Choose to validate if value is notEmpty
   */
  validateNotEmpty: bool,

  /**
   * Choose to customize error message
   */
  editError: bool,

  /**
   * Customize error text
   */
  errorText: string,

  /**
   * Define if disabled.
   */
  disabled: bool
};
export default Select;